import CloseIcon from "@mui/icons-material/Close";
import { Button, IconButton, Input, TextField } from "@mui/material";
import MainContainer from "layout/MainContainer";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const AddCategory = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [profileImage, setProfileImage] = useState("");

  return (
    <MainContainer>
      {/* <Loader isLoad={loading} /> */}
      <div className="main_title fdx">
        <div>
          <h1>{id ? "Edit Category" : "Add Category"}</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
            Categories - {id ? "Edit Category" : "Add Category"}
          </p>
        </div>
        <div className="right_s align_right">
          <Button className="btn btn_orange" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>
      </div>

      <div className="cards">
        <form className="form">
          <div className="gap_p">
            <div className="control_group w_50">
              <label>Image</label>
              <div className="upload_box">
                <label>
                  {profileImage && (
                    <IconButton
                      className="crossIcon"
                      onClick={() => setProfileImage("")}
                    >
                      <CloseIcon />
                    </IconButton>
                  )}
                  <figure>
                    <img
                      src={
                        profileImage
                          ? profileImage
                          : "/static/images/user_placeholder.png"
                      }
                      alt="Upload"
                    />
                  </figure>
                  <IconButton className="uploadIcon">
                    <label htmlFor="icon-button-file">
                      <Button component="span" className="upload_image_btn">
                        <img src="/static/images/edit2_icon.svg" alt="Upload" />
                        <Input
                          sx={{ display: "none" }}
                          id="icon-button-file"
                          type="file"
                          inputProps={{
                            accept: "image/png,image/jpeg",
                          }}
                          onChange={(e: any) => {
                            // handleProfileUpload(e);
                            e.target.value = null;
                          }}
                        />
                      </Button>
                    </label>
                  </IconButton>
                </label>
              </div>
            </div>

            <div className="control_group w_50" />
            <div className="control_group w_50">
              <label>Name</label>
              <TextField
                variant="outlined"
                placeholder="Name"
                className="text_field"
                fullWidth
                hiddenLabel
                name="name"
                id="name"
                inputProps={{ maxLength: 80 }}
                // value={formik.values.name}
                // onChange={(val) => {
                //   if (val.target.value === " " || val.target.value === ".") {
                //   } else {
                //     formik.handleChange(val);
                //   }
                // }}
                // onBlur={formik.handleBlur}
                // helperText={formik.touched.name && formik.errors.name}
              />
            </div>
          </div>
          <div className="form_btn end">
            <Button
              className="btn btn_secondary"
              onClick={() => navigate("/categories")}
            >
              {id ? "Edit Category" : "Add Category"}
            </Button>
          </div>
        </form>
      </div>
    </MainContainer>
  );
};

export default AddCategory;
